
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Device } from '~/interfaces/device.interface';

@Component
export default class DatadogLinks extends Vue {
    @Prop() device!: Device;

    get datadogLink() {
        return `https://app.datadoghq.eu/logs?query=%40context.device_id%3A%22${this.device.id}%22&agg_m=count&agg_m_source=base&agg_t=count&cols=host%2Cservice&messageDisplay=inline&refresh_mode=sliding&storage=hot&stream_sort=desc&viz=stream&live=true`;
    }

}
